import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';

export const createI18nInstance = () =>
  createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en },
    globalInjection: true,
  });

export type I18nInstance = ReturnType<typeof createI18nInstance>;
export const i18n = createI18nInstance();
